export const LEGAL_WRAPPER = [
  { id: 'DIRECT', displayValue: 'Direct' },
  { id: 'ISA', displayValue: 'ISA' },
  { id: 'SIPP', displayValue: 'SIPP' },
  { id: 'SSAS', displayValue: 'SSAS' },
];
